module.exports = __webpack_public_path__ + "img/img3.2b9e8620.png";